"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPieChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var forEach_1 = tslib_1.__importDefault(require("lodash/forEach"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucketRules_1 = require("./../bucketRules");
var bucketHelper_1 = require("./../bucketHelper");
var translations_1 = require("./../translations");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/pie/bucket-title-measures.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/pie/bucket-title-view.svg"));
var propertiesHelper_1 = require("../propertiesHelper");
function setPieChartBucketWarningMessages(referencePoint, intl) {
    var buckets = referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.buckets;
    var updatedUiConfig = cloneDeep_1.default(referencePoint === null || referencePoint === void 0 ? void 0 : referencePoint.uiConfig);
    forEach_1.default(buckets, function (bucket) {
        var _a, _b;
        var localIdentifier = (_a = bucket === null || bucket === void 0 ? void 0 : bucket.localIdentifier) !== null && _a !== void 0 ? _a : "";
        var bucketUiConfig = (_b = updatedUiConfig === null || updatedUiConfig === void 0 ? void 0 : updatedUiConfig.buckets) === null || _b === void 0 ? void 0 : _b[localIdentifier];
        // skip disabled buckets
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.enabled)) {
            return;
        }
        if (!(bucketUiConfig === null || bucketUiConfig === void 0 ? void 0 : bucketUiConfig.canAddItems)) {
            var warningMessageId = void 0;
            if (bucket.localIdentifier === sdk_ui_1.BucketNames.VIEW) {
                warningMessageId = "dashboard.bucket.category_category_by_warning";
            }
            if (warningMessageId) {
                var warningMessage = translations_1.getTranslation(warningMessageId, intl);
                set_1.default(updatedUiConfig, [bucket_1.BUCKETS, localIdentifier, "warningMessage"], warningMessage);
            }
        }
    });
    return updatedUiConfig;
}
function setPieChartUiConfig(referencePoint, intl, visualizationType) {
    var _a;
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    var buckets = (_a = referencePointConfigured === null || referencePointConfigured === void 0 ? void 0 : referencePointConfigured.buckets) !== null && _a !== void 0 ? _a : [];
    var measuresCanAddItems = !bucketRules_1.hasMoreThanOneCategory(buckets);
    var viewCanAddItems = !bucketRules_1.hasMoreThanOneMasterMeasure(buckets, sdk_ui_1.BucketNames.MEASURES);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, bucketHelper_1.setBucketTitles(referencePoint, visualizationType, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "canAddItems"], measuresCanAddItems);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "canAddItems"], viewCanAddItems);
    set_1.default(referencePointConfigured, uiConfig_1.UICONFIG, setPieChartBucketWarningMessages(referencePointConfigured, intl));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, uiConfig_1.OPEN_AS_REPORT, uiConfig_1.SUPPORTED], !propertiesHelper_1.hasColorMapping(referencePoint.properties));
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], bucket_title_view_svg_1.default);
    return referencePointConfigured;
}
exports.setPieChartUiConfig = setPieChartUiConfig;
//# sourceMappingURL=pieChartUiConfigHelper.js.map